.tip {
  position: absolute;
  z-index: 5;
  max-width: 260px;
  padding: 7px 10px;
  border-radius: var(--radius-chip);
  background: var(--tip-bg);
  box-shadow: var(--shadow-pop);
  color: var(--tip-ink);
  font-size: var(--t-min);
  line-height: 1.4;
  pointer-events: none;
  transform: translate(-50%, calc(-100% - 8px));
}

.tip b {
  display: block;
  margin-bottom: 2px;
}
